import React from "react"
import { Creatable } from "react-select"

import { licenseOptions } from "../../../../config/application-definitions"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"


import SelectTags from "../../../common/tags/SelectTags"

export default ({
    fulltext,
    isFetchingFulltext,
    summary,
    authors,
    license,
    onValueChange,
    onEventChange
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-article" />Article
            </h3>
            <ContentLoaderLines isFetching={isFetchingFulltext} lines={5}>
                <textarea
                    className="form-control article-content"
                    name="fulltext"
                    disabled={true}
                    value={fulltext}
                />
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-article" />Article summary
            </h3>
            <textarea
                className="form-control article-summary"
                name="summary"
                value={summary}
                onChange={onEventChange}
            />
            <h3>
                <span className="icon icon-authors" />Authors
            </h3>
            <div className="authors">
                <SelectTags
                    name="authors"
                    SelectComponent={Creatable}
                    value={authors}
                    onChange={onValueChange("authors")}
                    labelKey="label"
                />
            </div>
            <h3>
                <span className="icon icon-license" />License
            </h3>
            <select
                className="form-control"
                name="license"
                value={license}
                onChange={onEventChange}
            >
                {licenseOptions.map(licenseOption => (
                    <option value={licenseOption} key={licenseOption}>
                        {licenseOption}
                    </option>
                ))}
            </select>
        </div>
    </div>
)
